import React from 'react';
import { motion, Variants } from 'framer-motion';
import { Box, BoxProps } from '@mui/material';

const utilityVariants: Variants = {
  visible: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.25
    }
  },
  hidden: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.35,
      delay: 0.25
    }
  }
};

export type UtilOnHoverWrapperProps = BoxProps & {
  utility: React.ReactNode;
};

export const UtilOnHoverWrapper = ({
  utility,
  children,
  ...props
}: UtilOnHoverWrapperProps) => (
  <Box
    display="flex"
    alignItems="center"
    gap={1}
    component={motion.div as any}
    initial="hidden"
    whileHover="visible"
    {...props}
  >
    <span>{children}</span>
    <motion.div variants={utilityVariants}>{utility}</motion.div>
  </Box>
);
